import { Link } from '@cian/ui-kit/link';
import * as React from 'react';

import * as style from './style.css';
import { useDeviceType } from '@cian/ui-kit';

export interface ICompareToastContentProps {
  text: string;
  comparisonUrl?: string;
  onClick(): void;
}

export function CompareToastContent({ text, comparisonUrl, onClick }: ICompareToastContentProps) {
  const device = useDeviceType();
  const fontWeight = device === 'desktop' ? 'bold' : 'normal';

  return (
    <div className={style['container']}>
      <span>{text}</span>
      {comparisonUrl && (
        <span className={style['link']}>
          <Link
            href={comparisonUrl}
            color="current_color"
            fontSize="M"
            fontWeight={fontWeight}
            inline
            target="blank"
            onClick={onClick}
          >
            Посмотреть
          </Link>
        </span>
      )}
    </div>
  );
}
